export function getValue(row, key) {
  if (!row || typeof row !== 'object') {
    return '';
  }
  var value = row[key];
  return value === null || value === undefined ? '' : String(value);
}

export function getRowsColumns(rows) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [];
  }

  var first = rows[0];
  if (!first || typeof first !== 'object') {
    return [];
  }

  return Object.keys(first);
}

export function safeLower(value) {
  return String(value || '').toLowerCase();
}
